import React from "react";

import { FirestoreDocument } from "common";

const Document = (props) => {
  return <FirestoreDocument {...props} collection="partner_users" />;
};

export default Document;
